import React from 'react';
import { View } from 'react-native';

import Text from '../../react-component/textComponent';

import styles from './styles';

export default (props) => {
    const { title = 'Nenhum registro encontrado' } = props;

    return (
        <View {...props} style={[props.style, styles.emptyState]}>
            <Text style={styles.emptyStateText}>{title}</Text>
        </View>
    );
};
